var swiper = new Swiper(".collectionScroll-Slider", {
    pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
    },
    watchSlidesProgress: true,
    slidesPerView: 3,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    spaceBetween: 10,
    breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
         500: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
        
    }
});